// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accordion/accordion.component.scss
// module id = 76
// module chunks = 0